// @todo: Migrate to 'Icon' from @wandb/components. For more details see:
// https://wandb.github.io/components/?path=/docs/migration-guide--docs
// eslint-disable-next-line wandb/no-deprecated-imports
import {Icon, type IconName} from '@wandb/weave/components/Icon';
// @todo: Migrate to 'Tooltip' from @wandb/components. For more details see:
// https://wandb.github.io/components/?path=/docs/migration-guide--docs
// eslint-disable-next-line wandb/no-deprecated-imports
import {Tooltip} from '@wandb/weave/components/Tooltip';
import {clsx} from 'clsx';
import _ from 'lodash';
import React, {useRef} from 'react';
import useResizeObserver from 'use-resize-observer';

import {useIsTextOverflowing} from '../../../../util/hooks/useIsTextOverflowing';

type Cell = {
  component?: React.ReactNode | string;
  iconName?: IconName;
  iconClassName?: string;
  classNameOverride?: string;
};

const ContentWithTooltip = ({
  cell: {component, classNameOverride, iconName, iconClassName},
}: {
  cell: Cell;
}) => {
  const parentDomRef = useRef<HTMLDivElement | null>(null);
  const isTextOverflowing = useIsTextOverflowing({
    text: _.isString(component) ? component : '',
    parentDomRef,
  });
  const {ref: triggerDomRef} = useResizeObserver<HTMLDivElement>();

  const content = (
    <div ref={triggerDomRef} className={classNameOverride ?? 'w-full truncate'}>
      {component}
    </div>
  );
  const contentWithTooltip = isTextOverflowing ? (
    <Tooltip content={content} trigger={content} />
  ) : (
    component
  );
  return (
    <div
      className={classNameOverride ?? 'flex w-full items-center truncate p-8'}
      ref={parentDomRef}>
      {iconName != null && (
        <div className={clsx('pr-8', iconClassName)}>
          <Icon name={iconName} width={18} height={18} />
        </div>
      )}
      {contentWithTooltip}
    </div>
  );
};

export const SelectableTableRow = ({
  cells,
  isSelected,
  onClick,
}: {
  cells: Cell[];
  isSelected: boolean;
  onClick?: () => void;
}) => {
  return (
    <div
      data-test="selectable-table-row"
      onClick={onClick}
      onKeyDown={({key}) => {
        if (onClick && key === 'Enter') {
          onClick();
        }
      }}
      className={clsx(
        isSelected
          ? 'bg-teal-300/30 hover:bg-teal-300/30'
          : 'bg-white hover:bg-oblivion/[0.04]',
        'flex last:rounded-b-lg',
        onClick != null ? 'cursor-pointer' : 'cursor-auto'
      )}>
      {cells.map((cell, i) => (
        <ContentWithTooltip cell={cell} key={i} />
      ))}
    </div>
  );
};
